// extracted by mini-css-extract-plugin
export var chip = "_3i-9";
export var chipLabel = "_3i-a";
export var close = "_3i-7";
export var closeIcon = "_3i-8";
export var error = "_3i-6";
export var infoTooltip = "_3i-2";
export var innerContainer = "_3i-1";
export var input = "_3i-b";
export var medium = "_3i-5";
export var outerContainer = "_3i-0";
export var small = "_3i-4";
export var xSmall = "_3i-3";